import { VoziqOffer } from './types';

const KindLabels = {
    Rmr: 'Lower monthly rate',
    Coupon: 'Shop coupon',
    Equipment: 'Equipment offer'
};

class VoziqOffersModalController {
    public resolve: { offers: VoziqOffer[] };
    public close: (result: { $value: VoziqOffer }) => void;
    public dismiss: () => void;

    public kindLabel(offer: VoziqOffer) {
        return KindLabels[offer.Kind];
    }

    public select(offer: VoziqOffer) {
        this.close({ $value: offer });
    }
}

export const voziqOffersModal = {
    template: require('./voziqOffersModal.html'),
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controller: VoziqOffersModalController
};
